import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import '@components/Footer/Footer.css';

import { PRIVACY_AND_GDPR_URL } from '@config/const';

export const Footer = () => (
  <footer className="footer fixed-bottom mt-auto py-3 bg-didxl border-top">
    <div className="container text-white">
      <Row>
        <Col md={4} className="text-start">
          © 2024 DidXL. All Rights Reserved.
        </Col>
        <Col md={4}>Sitemap</Col>
        <Col md={4} className="text-end">
          <Link
            className="text-decoration-none text-white"
            to={PRIVACY_AND_GDPR_URL}
            target="_blank"
          >
            Privacy and GDPR policy
          </Link>
        </Col>
      </Row>
    </div>
  </footer>
);
